<!-- 点群、設計などToolPanelに一覧表示されるアイテムのラベル名用コンポーネント -->
<script setup>
import InfoTooltip from "@/components/common/InfoTooltip";

defineProps({
	text: String,
	icon: {
		type: String,
		default: "",
	},
});
</script>

<template>
  <InfoTooltip class="tooltip-wrapper" placement="bottom" :triggers="['hover']">
    <div class="list-item-content">
      <v-icon v-if="icon" size="14" class="list-item-icon">{{ icon }}</v-icon>
      <span class="list-item-label">{{ text }}</span>
    </div>
    <template #popper>
      <span class="text-black">{{ text }}</span>
    </template>
  </InfoTooltip>
</template>

<style lang="scss" scoped>
.tooltip-wrapper {
  flex: 1;
  min-width: 0;
  display: flex;

  .list-item-content {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
    gap: 4px;
  }

  .list-item-icon {
    flex: 0 0 auto;
  }

  .list-item-label {
    min-width: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
